import styled from '@emotion/styled';
// ---- external imports ----

import rightProjection from '~/assets/images/baseAssets/right.png';
import { withProjection } from '~/hoc';
// ---- internal imports ----

import Asset from '../BaseAssets';
// ---- parent imports ----

const RightArrowButton = styled(
	withProjection(Asset.Button, rightProjection))`
	${({ disabled }) => disabled ? 'display:none;' : ''}
`;


export default RightArrowButton;
